import CheckBoxChecked from "images/icons/checkbox_checked.svg";
import utilStyles from "styles/utils.module.scss";
import CheckBoxUnchecked from "images/icons/checkbox_unchecked.svg";


export const CheckBox = (props) => {
    const {isChecked, toggle} = props;

    return (
        <div onClick={toggle}>
        {
            isChecked ?
                <CheckBoxChecked viewBox="0 0 24 24" width={24} height={24}
                                 className={utilStyles.verticalMiddle}/>
                :
                <CheckBoxUnchecked viewBox="0 0 24 24" width={24}
                                   height={24}
                                   className={utilStyles.verticalMiddle}/>
        }
        </div>
    )
};
